module.exports = __webpack_public_path__ + "img/holografica.c27fe6df.png";